import PropTypes from 'prop-types';
import { Icon, USER_INTERFACE_ARROW_04_RIGHT } from '@bwoty-web/styleguide';
import './linkPush.scss';

const LinkPush = ({ children, href, onClick, target, ...rest }) => {
  const isButton = !href;
  const RenderType = isButton ? 'button' : 'a';

  return (
    <RenderType
      {...rest}
      target={target}
      href={href}
      onClick={() => onClick()}
      className="gw-link-push"
    >
      {children}
      <Icon
        className="gw-link-push__icon"
        path={USER_INTERFACE_ARROW_04_RIGHT}
      />
    </RenderType>
  );
};

LinkPush.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
};

LinkPush.defaultProps = {
  href: null,
  onClick: null,
  target: null,
};

export default LinkPush;
